module.exports = __webpack_public_path__ + "img/aqfh-img-74.9df96cdd.png";